import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';

const EmptyKpiPlaceholder = ({ className, style, text }) => {
  return (
    <div className={cn('flex-1 row-center-center text-center', className)} style={{ color: '#777', ...style }}>
      {/* There is currently no data available for this KPI  */}
      {text}
    </div>
  );
};

const styles = theme => ({
  //
});

EmptyKpiPlaceholder.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
};

EmptyKpiPlaceholder.defaultProps = {
  style: {},
};

export default withStyles(styles)(EmptyKpiPlaceholder);
